<template>
  <v-container class="pa-0">
    <v-card>
      <v-toolbar dense flat dark :color="toolbarColor" rounded>
        <v-toolbar-title :class="headingClass">
          {{ activeResident.firstName }}'s {{ getExpression('FormTitle', 'MobileAppUsers') }}  ({{ userCount }})
        </v-toolbar-title>
      </v-toolbar>

      <v-card :loading="isLoading">
        <template v-slot:progress>
          <v-progress-linear indeterminate :color="appColor_Progress"></v-progress-linear>
        </template>

        <v-list-item class="pa-0">
          <v-virtual-scroll
            :items="users"
            :item-height="itemHeight"
            :height="scrollBoxHeight"
            >

            <template v-slot="{ item }">
              <v-list-item>
                <v-list-item-avatar>
                  <v-avatar size="30">
                    <v-img :src="getPicture(item.picture)" />
                  </v-avatar>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title :class="`${valueClass} ml-2`">
                    {{ item.name }}
                  </v-list-item-title>
                  <v-list-item-subtitle :class="`${valueClass} ml-2`">
                    {{ `(${item.functionalRole})` }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

              <v-divider />

            </template>
          </v-virtual-scroll>
        </v-list-item>
      </v-card>
    </v-card>
  </v-container>
</template>

<script>
import appService from '@/app.service.js'
import { mapGetters } from 'vuex'
import { AppColor, DashboardClass, ImageUri } from '@/config.js'

export default {
  name: 'MobileUsers',
  props: {
    scrollHeight: {
      type: Number,
      default: 172
    },
    toolbarColor: {
      type: String,
      default: AppColor.Light
    }
  },
  data() {
    return  {
      // colors
      appColor_Progress: AppColor.Progress,

      // styles
      headingClass: DashboardClass.Heading,
      labelClass: DashboardClass.Label,
      valueClass: DashboardClass.Value,

      users: [],
      isLoading: false,
      itemHeight: 60
    }
  },
  computed: {
    ...mapGetters(['activeResident']),
    userCount () {
      if (this.isNullOrUndefined(this.users)) return 0
      return this.users.length
    },
    scrollBoxHeight () {
      if (this.isNullOrUndefined(this.users)) return 60
      return (this.userCount * 60) >= 481 
        ? 481
        : (this.userCount * 60) + 1;
    },
    console: () => console,
    window: () => window
  },
  methods: {
    loadData () {
      const self = this

      self.isLoading = true
      appService.getResidentDashboardUsers(self.activeResident.id).then(data => {
        self.isLoading = false
        if (data.errorSeverity > 0) {
          self.handleError(data)
        } else {
          self.users = data.users

          const userItems = self.users.map((u) => { return {
            id: u.id,
            name: u.name,
            nickname: u.nickname,
            divider: true
          }})
          self.$emit('data-loaded', userItems)
        }
      }).catch(e => { self.handleCriticalError(e) })
    },

    handleError (result) {
      this.$error.show( {
        text: result.errorMessage,
        severity: result.errorSeverity
      })
    },

    getPicture (picture) {
      if (this.isNullOrUndefined(picture)) return ImageUri.NoAvatar

      return picture.indexOf('https://s.gravatar.com/') >= 0
        ? ImageUri.NoAvatar
        : picture
    }
  },
  created() {
    this.loadData()
  }
}
</script>
